import { CountryCode } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

/**
 * Further citizenships of a party. A cleared picker leaves null in its slot and a form that never
 * showed the field sends nothing; the party keeps only real codes.
 */
export const otherNationalitiesSchema = z
  .array(z.enum(CountryCode).nullable())
  .default([])
  .transform((codes) =>
    codes.filter((code): code is CountryCode => code != null),
  );

/** A further citizenship must differ from the primary one; the issue lands on the offending slot. */
type OtherNationalitiesIssuesArgs = {
  ctx: z.RefinementCtx;
  t: TFunction;
  nationality: CountryCode | null | undefined;
  otherNationalities: Array<CountryCode>;
};

export const addOtherNationalitiesIssues = ({
  ctx,
  t,
  nationality,
  otherNationalities,
}: OtherNationalitiesIssuesArgs) => {
  const duplicateIndex = nationality
    ? otherNationalities.indexOf(nationality)
    : -1;

  if (duplicateIndex >= 0) {
    ctx.addIssue({
      code: "custom",
      message: t(Resources.Validation.OtherNationalitySameAsPrimary),
      path: ["otherNationalities", duplicateIndex],
    });
  }
};
